import axiosInstance from './axiosInstance';

export interface User {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'admin' | 'editor' | 'viewer';
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: 'admin' | 'editor' | 'viewer';
}

export interface UpdateUserData {
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  role?: 'admin' | 'editor' | 'viewer';
}

export interface UsersListResponse {
  users: User[];
  ownerId: string | null;
}

// API Functions
export const userApi = {
  // GET /api/users - Get all users
  getAllUsers: async (): Promise<UsersListResponse> => {
    const response = await axiosInstance.get('/users');
    const data = response.data;
    if (Array.isArray(data)) {
      return { users: data, ownerId: null };
    }
    return data;
  },

  // GET /api/users/:id - Get user by ID
  getUserById: async (id: string): Promise<User> => {
    const response = await axiosInstance.get(`/users/${id}`);
    return response.data;
  },

  // POST /api/users - Create new user
  createUser: async (userData: CreateUserData): Promise<User> => {
    const response = await axiosInstance.post('/users', userData);
    return response.data;
  },

  // PUT /api/users/:id - Update user
  updateUser: async (id: string, userData: UpdateUserData): Promise<User> => {
    const response = await axiosInstance.put(`/users/${id}`, userData);
    return response.data;
  },

  // DELETE /api/users/:id - Delete user
  deleteUser: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/users/${id}`);
  },
};
